module.exports = __webpack_public_path__ + "static/media/york_logo.faa77689.svg";